import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { FreightQuoteResponse } from "@tCentro/Services/CENPDPFreightQuoteService";

import { Draft } from "immer";


interface FreightQuoteState {
    isLoading: boolean;
    freightQuoteData?: FreightQuoteResponse; // Store the freight quote data when available
}

const initialState: FreightQuoteState = {
    isLoading: false,
    freightQuoteData: undefined,
};

export default createTypedReducerWithImmer(initialState, {


    "Custom/FreightQuote/BeginLoad": (draft: Draft<FreightQuoteState>) => {
        draft.isLoading = true;
        draft.freightQuoteData = undefined; // Reset the data while loading
    },

    
    "Custom/FreightQuote/CompletedLoad": (
        draft: Draft<FreightQuoteState>,
        action: {
            result: FreightQuoteResponse; 
        },
    ) => {
        draft.isLoading = false;
        draft.freightQuoteData = action.result; 
    },

    
    "Custom/FreightQuote/FailedLoad": (draft: Draft<FreightQuoteState>) => {
        draft.isLoading = false;
        draft.freightQuoteData = undefined; 
    },
});
